/**
 * Previous/next unit navigation.
 */
import React, { useMemo } from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { useAsterController } from "context";
import { VButton, VText } from "form";
import { getPrevNextLinks } from "utils/course";

/**
 * Links to the previous and next verticals in the outline.
 */
const BoardPagination = () => {
  const { t } = useTranslation("common");

  const { courseId, sectionIndex, sequenceIndex, verticalIndex, preview } = useParams();
  const navigate = useNavigate();

  const [controller] = useAsterController();
  const { structure } = controller;

  const { prev, next } = useMemo(() => getPrevNextLinks(structure, sectionIndex, sequenceIndex, verticalIndex) || { prev: {}, next: {} }, [structure, sectionIndex, sequenceIndex, verticalIndex]);

  const onClick = (route) => navigate(route);

  return (
    <>
      <Box className="w-full flex justify-between py-10 px-4">
        <Box className="w-5/12">
          <VButton variant="outlined" color="primary" className="px-4 gap-1 w-28" onClick={() => onClick(`/${preview ? "preview" : "content"}/${courseId}/${prev.route}`)} disabled={!prev.route}>
            <Icon icon="akar-icons:chevron-left" className="flex-shrink-0" />
            {t("Previous")}
          </VButton>

          <VText className="invisible sm:visible text-lg text-limit-1 mt-4" color="secondary">
            {prev.title}
          </VText>
        </Box>
        <Box className="flex flex-col items-end w-5/12">
          <VButton variant="contained" color="primary" className="px-4 gap-1 w-28" onClick={() => onClick(`/${preview ? "preview" : "content"}/${courseId}/${next.route}`)} disabled={!next.route}>
            {t("Next")}
            <Icon icon="akar-icons:chevron-right" className="flex-shrink-0" />
          </VButton>
          <VText className="invisible sm:visible text-lg text-limit-1 mt-4" color="secondary" div>
            {next.title}
          </VText>
        </Box>
      </Box>
    </>
  );
};

export default BoardPagination;
